import * as currency from '@shopify/theme-currency';
import '../../styles/components/range.scss';

class Range extends HTMLElement {
  constructor() {
    super();

    this.step = this.getAttribute('step') || 1;

    this.upperInput = this.querySelector('input[type="range"][upper-range]');
    this.lowerInput = this.querySelector('input[type="range"][lower-range]');

    this.upperInput.addEventListener('input', this.inputChange.bind(this));
    this.lowerInput.addEventListener('input', this.inputChange.bind(this));
  }

  inputChange(event) {
    const currentInput = event.currentTarget;

    
    if(currentInput.hasAttribute('lower-range')) {
      
      if(parseInt(currentInput.value) >= parseInt(this.upperInput.value)) {
        currentInput.value = parseInt(this.upperInput.value) - parseInt(this.step);
      }
    }

    if(currentInput.hasAttribute('upper-range')) {
      if(parseInt(currentInput.value) <= parseInt(this.lowerInput.value)) {
        currentInput.value = parseInt(this.lowerInput.value) + parseInt(this.step);
      }
    }
  
    let currentValue = currentInput.value;
    if(this.hasAttribute('currency')) {
      currentValue = currency.formatMoney(currentInput.value * 100, this.getAttribute('currency'));
    }
    currentValue = `"${currentValue}"`;

    if(currentInput.hasAttribute('lower-range')) {
      this.style.setProperty(`--lower-range`, currentValue);
    }

    if(currentInput.hasAttribute('upper-range')) {
      this.style.setProperty(`--upper-range`, currentValue);
    }
  }
}

try {
  customElements.define('range-el', Range);
}
catch(e) {
  console.log("range-el already defined", e)
}